import React from "react";

import "./Details.css";
import Navbar from "../NavBar/Navbar";

const Details = () => {
  return (
    <div className="detailsContainer">
      <div className="nav">
        <Navbar />
      </div>
      <div className="upperGradient" />

      <div className="detailsWrapper">
        <div className="detailsText">
          <div>
            <p className="ecommerceHeading detailHeader">
              Let me introduce myself.
            </p>
          </div>
          <div className="introductionBox">
            <p className="detailIntroduction">
              Hi, my name is Faruk Suljagic, I was born in the year 2000, and I
              am a Junior Front-end Developer.
            </p>
            <p>
              I started coding about 2 years ago and have been going strong ever
              since. I first started with the basics like <strong>HTML</strong>{" "}
              & <strong>CSS</strong>, after that, I started learning the concept
              of <strong>JavaScript</strong> and finally made a quick switch to
              Reactjs for Speed, Flexibility and all the good stuff React offers
              such as <strong>Hooks</strong>, <strong>Redux</strong>,{" "}
              <strong>Props</strong>, etc. In React I have worked with:
              <ul>
                <li>
                  <strong>API's</strong> (Adding, Deleting, Removing, Increase /
                  Decrease)
                </li>
                <li>
                  <strong>Hooks</strong>
                </li>
                <li>
                  <strong>Props</strong>
                </li>
                <li>
                  <strong>Redux</strong>
                </li>{" "}
                <li>
                  <strong>React-three</strong> for small animations (glTF)
                </li>{" "}
                <li>
                  <strong>Nodejs</strong> (for running projects on local server)
                </li>{" "}
                <li>
                  <strong>NPM / Yarn</strong>
                </li>
              </ul>
              and the plan is to continuously expand my knowledge.
              <br />
              <br />I have finished a 6-month Internship program at the firm
              <a
                rel="noreferrer"
                href="https://motiff.network/"
                className="motiffBtn"
                target="_blank"
              >
                Motiff Network
              </a>
              , where I have worked in teams, sprints, and the usual things such
              as team meetings, presentations, etc.
            </p>
          </div>
        </div>
      </div>
      <div className="lowerGradient" />
    </div>
  );
};

export default Details;
